export const tableHeaderColumns = ['Add', 'Crop', 'Price', 'Name', 'Variety', 'Genetic type', 'Notes'];
